module.exports = __webpack_public_path__ + "static/media/gallery10.5fdba395.jpg";